import { DbCreatePosition } from "../../../data/usecases/create-position";
import { CreatePosition } from "../../../domain/usecases/create-position";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbCreatePosition = (): CreatePosition =>
  new DbCreatePosition(
    makeApiUrl("/position"),
    makeAuthorizeHttpClientDecorator()
  );
